export const sxConfig = {
  drillArrowIconButton: {
    marginLeft: '0.4rem',
    padding: 0,
  },
  drillArrowIcon: {
    color: 'black',
    fontWeight: 'bold',
    background: 'rgba(240, 237, 45, 0.74)',
    border: '1px solid #bbb',
    borderRadius: '4px',
    fontSize: '1.6rem',
  },
  debouncedInputendAdornment: {
    cursor: 'pointer',
  },
  debouncedInputLabelColor: {
    color: '#607d8b',
  },
  debouncedInputPaper: {
    p: 2,
    width: 500,
  },
  debouncedInputPaperBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
    mb: 2,
  },
  debouncedInputChip: {
    mr: 0.5,
  },
  loaderWrapper: {
    position: 'fixed',
    inset: 0,
    zIndex: 10000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loaderBackdrop: {
    position: 'fixed',
    inset: 0,
    bgcolor: 'rgba(0, 0, 0, 0.57)',
  },
  loaderContent: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
  },
  loaderText: {
    fontSize: '1.1rem',
    fontWeight: 500,
    color: '#fff',
    fontFamily: 'inherit',
    minWidth: '9ch',
    letterSpacing: '.5px',
  },

  dialogActionContent: {
    backgroundColor: '#f5f5f5',
    px: 2,
    py: 0.75,
    borderRadius: 1,
    border: '1px solid #e0e0e0',
  },

  dialogActionContentTypography1: {
    color: 'text.secondary',
  },

  dialogActionContentTypography2: {
    fontWeight: 600,
    color: 'text.primary',
  },

  pinCodeVisibilityIcon: {
    fontSize: '1.8rem',
    color: '#3A4756',
    cursor: 'pointer',
  },
};
